import React, { useCallback } from 'react';
import { useSelector } from '@xstate/react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from '../shared/layout';
import { BillingInterval, Plan } from './types';
import CheckoutDialog from './checkout-dialog';
import PlanCard from './plan-card';
import Toast from './toast';
import { usePlanSelect } from './service/plan-select-service';

const plansSelector = (state: any) => state.context.plans;
const currentPlanSelector = (state: any) => state.context.currentPlan;
const minConversionLicensesSelector = (state: any) => state.context.minConversionLicenses;
const toastMessageSelector = (state: any) => state.context.toastMessage;
const toastSeveritySelector = (state: any) => state.context.toastSeverity;

const PlanSelect: React.FC = () => {
  const planInterpreter = usePlanSelect();
  const plans = useSelector(planInterpreter, plansSelector);
  const currentPlan = useSelector(planInterpreter, currentPlanSelector);
  const minConversionLicenses = useSelector(planInterpreter, minConversionLicensesSelector);
  const toastMessage = useSelector(planInterpreter, toastMessageSelector);
  const toastSeverity = useSelector(planInterpreter, toastSeveritySelector);

  const handleSelectPlan = (plan: Plan, billingInterval: BillingInterval) => {
    planInterpreter.send({ type: 'SELECT_PLAN', plan, billingInterval });
  };

  const handleCloseToast = useCallback(() => {
    planInterpreter.send({ type: 'CLOSE_TOAST' });
  }, []);

  return (
    <>
      <CssBaseline />
      <Layout layoutTitle="Change your plan">
        <>
          <Box sx={{
            display: 'flex', flexDirection: 'column', gap: 6, pb: 6,
          }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 3fr))',
                gap: 2,
                paddingTop: 2,
              }}
              >
                {plans.map((plan: Plan) => (
                  <PlanCard
                    key={plan.publicSlug}
                    plan={plan}
                    currentPlan={currentPlan}
                    minConversionLicenses={minConversionLicenses}
                    onSelectPlan={handleSelectPlan}
                  />
                ))}
              </Box>
              <Box>
                * Monthly pricing only available on Professional plans during the
                first 12 months as a Fulcrum customer. We will learn your usage
                pattern and offer appropriate pricing with an annual commitment.
              </Box>
            </Box>
          </Box>
          <CheckoutDialog />
          <Toast
            message={toastMessage}
            severity={toastSeverity}
            onClose={handleCloseToast}
          />
        </>
      </Layout>
    </>
  );
};

export default PlanSelect;
